import Link from 'base/components/Link/Link';

export default Link;
